import { render, staticRenderFns } from "./subitemV4.vue?vue&type=template&id=7b8d3218&scoped=true&"
import script from "./subitemV4.vue?vue&type=script&lang=js&"
export * from "./subitemV4.vue?vue&type=script&lang=js&"
import style0 from "./subitemV4.vue?vue&type=style&index=0&id=7b8d3218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d3218",
  null
  
)

export default component.exports